import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PendingTrigger } from './types';
import { Field } from 'hellospa/components/editor/types';
import { Trigger, AllowedTriggerField } from 'hellospa/conditional-logic/types';
import {
  operatorsForFields, isAllowedFieldType,
} from 'hellospa/conditional-logic';
import * as Dropdown from 'hellospa/foundation/control/dropdown';
import styles from './rules-panel.scss';

/**
 * Populates the dropdown based on the field type
 * @param triggerField the trigger field being used
 * @param trigger the trigger that's part of the rule
 * @param onChange handler to update the operator property
*/
type Props = {
  triggerField: Field,
  trigger: PendingTrigger,
  onChange: (triggerType: AllowedTriggerField, operator: Trigger['operator']) => void,
};

function TriggerOperatorDropdown({
  triggerField, trigger, onChange,
}: Props): JSX.Element | null {
  if (!isAllowedFieldType(triggerField.type)) {
    return null;
  }

  const triggerType = triggerField.type;
  const operators = Object.keys(operatorsForFields[triggerType]) as Array<Trigger['operator']>;

  // get the operator from the trigger
  const selectedOperator = trigger.operator;

  const dropdownOptions: JSX.Element[] = operators.map((operator) => {
    return (
      <Dropdown.MenuItem key={operator} value={operator} tag="li">
        {operatorsForFields[triggerType][operator]}
      </Dropdown.MenuItem>
    );
  });

  return (
    <Dropdown.Wrapper
      onSelection={(value, _name) => onChange(triggerType, value)}
      kind="small"
      className={styles.operatorDropdown}
    >
      <Dropdown.Button data-qa-ref="rules-panel-option-select">
        {operatorsForFields[triggerType][selectedOperator] || (
          <FormattedMessage
            id=""
            description="dropdown text in editor asking user to select one the of the options from dropdown"
            defaultMessage="Select" />
        )}
      </Dropdown.Button>
      <Dropdown.Menu tag="ul">
        {dropdownOptions}
      </Dropdown.Menu>
    </Dropdown.Wrapper>
  );
}


export default React.memo(TriggerOperatorDropdown);
